import * as Rx from 'rxjs';
import * as RxOp from 'rxjs/operators';
import { getPosApiUrl, getAccessToken } from '../../utils/state';
import {
  cashDropAlertBarAction,
  SUBMIT_CASH_DROP_FORM,
  postCashDropSuccess,
} from './CashDrop.state';
import { postCashDrop } from '../../utils/api/client';
import { caughtError } from '../../utils/api/errorHandler';
import { replaceAlerts } from '../../components/alert-bar/AlertBar.state';

const caughtCashDropErrorCallback = (state) =>
  caughtError(cashDropAlertBarAction, 'Cash Drop Page Error:', state);

export const cashDropErrorEpic = ({ errorMessage }) =>
  Rx.of(
    cashDropAlertBarAction(
      replaceAlerts({
        heading: 'Cash Drop Error',
        text: errorMessage,
        variant: 'error',
      }),
    ),
  );

const postCashDropParams = (state, payload) => {
  return {
    url: getPosApiUrl(state),
    token: getAccessToken(state),
    data: {
      cash_action: payload,
    },
  };
};

export const postCashDropEpic = (action$, state$) =>
  action$.ofType(SUBMIT_CASH_DROP_FORM).pipe(
    RxOp.flatMap((action) =>
      Rx.from(
        postCashDrop(postCashDropParams(state$.value, action.payload)),
      ).pipe(
        RxOp.flatMap((response) => {
          action.payload.navigate(`/pos/cashaction/${response.data.id}`);
          return Rx.of(postCashDropSuccess(response.data));
        }),
        RxOp.catchError((err) =>
          caughtCashDropErrorCallback(state$.value)(err),
        ),
      ),
    ),
  );
